// Helpers de filtro por período usados em listagens pesadas — exige período
// (datas obrigatórias) e limita o intervalo máximo em dias.
// Centralizado aqui para reuso entre telas (PagamentosRemessas, relatórios, etc.).

export const DEFAULT_PERIODO_MAX_DIAS = 31;
const MS_POR_DIA = 24 * 60 * 60 * 1000;

const toIsoDate = (d) => d.toISOString().slice(0, 10);

/**
 * Devolve { inicial, final } em formato 'YYYY-MM-DD' para preencher filtros
 * com período padrão de `dias` corridos terminando em hoje.
 */
export const getDefaultPeriodoRange = (dias = DEFAULT_PERIODO_MAX_DIAS) => {
  const hoje = new Date();
  const inicio = new Date(hoje.getTime() - (dias - 1) * MS_POR_DIA);
  return { inicial: toIsoDate(inicio), final: toIsoDate(hoje) };
};

/**
 * Valida o par (dataInicial, dataFinal) no formato 'YYYY-MM-DD'.
 * Regras:
 *   - ambas obrigatórias;
 *   - precisam ser datas válidas;
 *   - dataFinal >= dataInicial;
 *   - intervalo total (inclusivo) <= maxDias.
 *
 * Retorna { valid, mensagem } — `mensagem` traz texto pronto para toast
 * quando `valid=false`.
 */
export const validatePeriodoRange = (
  dataInicial,
  dataFinal,
  maxDias = DEFAULT_PERIODO_MAX_DIAS,
) => {
  if (!dataInicial || !dataFinal) {
    return { valid: false, mensagem: 'Data inicial e data final são obrigatórias.' };
  }
  const ini = new Date(`${dataInicial}T00:00:00`);
  const fim = new Date(`${dataFinal}T00:00:00`);
  if (Number.isNaN(ini.getTime()) || Number.isNaN(fim.getTime())) {
    return { valid: false, mensagem: 'Datas inválidas.' };
  }
  if (fim < ini) {
    return { valid: false, mensagem: 'A data final não pode ser menor que a inicial.' };
  }
  const diffDias = Math.round((fim - ini) / MS_POR_DIA) + 1;
  if (diffDias > maxDias) {
    return { valid: false, mensagem: `O período máximo permitido é de ${maxDias} dias.` };
  }
  return { valid: true, mensagem: '' };
};
